<template lang="pug">
.new-unistar-campaign(v-loading="loading")
  .new-unistar-campaign__header
    el-breadcrumb(
      separator="/"
    )
      el-breadcrumb-item(
        :to="{ path:'/unistar/list' }"
      ) {{ $t('项目列表') }}
      el-breadcrumb-item {{ $t('创建项目')}}
  el-alert(
    v-if="userStatus && userStatus !== '1'"
    :title="alertText"
    type="warning"
  )
  title-bar
    span {{ $t('项目信息') }}
  .new-unistar-campaign__form
    el-form(
      ref="form"
      :model="form"
      :v-model="form"
      :rules="rules"
      label-width="180px"
    )
      el-form-item.form-item(
        :label="$t('名称')"
        prop="campaign_name"
      )
        el-input(v-model="form.campaign_name")
      el-form-item.form-item(
        :label="$t('明星')"
      )
        span {{ starList.map(i => i.star_name).join('，') }}
      el-form-item.form-item(
        label="Function"
        prop="function_type"
      )
        el-select(
          v-model="form.function_type"
          @change="onChangeFunction"
        )
          el-option(
            v-for="o, i in functionList"
            :key="i"
            :value="o.id"
            :label="o.name"
          )
      el-row.brand-row(
        v-for="(item, index) in form.campaign_brand"
        :key="index"
      )
        el-col.brand-container
          el-form-item(
            :label="$t('品牌类别')"
            :prop="'campaign_brand[' + index + '].brand_category_id'"
            :rules="{required:true,message: $t('请选择品牌类别'),trigger: 'change'}"
          )
            el-select(
              :disabled="isView"
              v-model="item.brand_category_id"
              :placeholder="$t('请选择品牌类别')",
              @change="(val) => { onBrandCategoryChange(val, index) }"
            )
              el-option(
                v-for="o, i in brandCategorys"
                :key="i"
                :value="o.brand_category_id"
                :label="o.brand_category_name"
              )
          el-form-item(
            :label="$t('品牌')"
            :prop="'campaign_brand[' + index + '].brand_id'"
            :rules="{required:true,message: $t('请选择品牌'),trigger: 'change'}"
          )
            el-select(
              :disabled="isView"
              v-model="item.brand_id"
              :placeholder="$t('请选择品牌')"
            )
              el-option(
                v-for="o, i in brandLists[index]"
                :key="i"
                :value="o.brand_id"
                :label="o.brand_name"
                :disabled="shouldDisabledBrand(index, o.brand_id)"
              )
        el-col(
          v-if="index !== 0"
          :span="3"
        )
          el-button.delete-brand__btn(
            type="text"
            @click="handleDeleteBrand(index)"
          ) {{ $t('删除') }}
      el-form-item.form-item(
        v-if="form.function_type !== 1"
      )
        span(
          :style="{ color: '#00a0e5', cursor: 'pointer' }"
          @click="handleAddBrand"
        ) + {{ $t('添加品类/品牌') }}
      el-form-item.form-item(
        :label="$t('合作性质')"
        prop="cooperation_type"
      )
        el-radio-group(v-model="form.cooperation_type")
          el-radio(
            :label="1"
          ) {{ $t('品牌代言') }}
          el-radio(
            :label="2"
          ) {{ $t('项目大使') }}
      el-form-item.form-item(
        :label="$t('描述')"
        prop="introduction"
      )
        el-input(
          v-model="form.introduction"
          type="textarea"
          :rows="8"
          style="width: 380px"
          :placeholder="$t('不多于500字')"
        )
    title-bar
      span {{ $t('Brief') }}
    el-row(style="margin-left:20px")
      el-col.required(style="width:180px") {{ $t('附件') }}
      el-col(:span="12")
        div(style="display: flex")
          new-upload-file(
            style="margin-right: 5px"
            axiosUrl="/management/subfinal/saveFile"
            :params="{ file_type: 1 }"
            @loadingChange="status => loading = status"
            @uploadSuccess="uploadSuccess"
          )
          uploaded-file-display(
            :fileName="campaign_attachment.file_name"
            :downloadUrl="campaign_attachment.file_download_path"
            :fileNameList="campaign_attachment.file_name_list"
          )
    el-row(style="margin-left:20px")
      el-col(style="width:180px") {{ $t('期望权益') }}
      el-col(:span="10")
        el-input(
          v-model="campaign_attachment.remark"
          type="textarea"
          :rows="8"
          style="width: 380px"
          :placeholder="$t('不多于500字')"
          :class="{'has-error': errors.has('remark_field') }"
          v-validate="'max:500'"
          data-vv-as="remark_field"
          name="remark_field"
        )
        p(class="input-error" style="margin-left:17%") {{ errors.first('remark_field') }}
    footer-button(
      :confirmButton="$route.query.campaignId ? $t('保存') : $t('创建')"
      @confirm="onConfirm('form')"
      @cancel="cancel"
    )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import FooterButton from '@/components/FooterButton'
import InputWithCommas from '@/components/InputWithCommas'
import VueNumeric from '@/components/VueNumeric'
import NewUploadFile from '@/components/NewUploadFile'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import db from '@/umcc/db'

export default {
  components: {
    TitleBar,
    FooterButton,
    InputWithCommas,
    VueNumeric,
    NewUploadFile,
    UploadedFileDisplay

  },
  data () {
    let validateCampaignName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入项目名称')))
      } else if (value.length > 50) {
        callback(new Error(this.$t('项目名称不多于50字')))
      } else {
        callback()
      }
    }

    let validateIntro = (rule, value, callback) => {
      if (value && value.length > 500) {
        callback(new Error(this.$t('描述不多于500字')))
      } else {
        callback()
      }
    }

    return {
      userStatus: 0,
      alertText: '',
      functionList: [
        {
          id: 1,
          name: 'Brand'
        },
        {
          id: 2,
          name: 'EC'
        },
        {
          id: 3,
          name: 'CD'
        }
      ],
      isSaved: false,
      brandLists: [],
      loading: false,
      brandCategorys: [],
      starList: [],
      form: {
        campaign_name: '',
        campaign_brand: [{
          brand_category_id: '',
          brand_id: ''
        }],
        start_date: '',
        end_date: '',
        introduction: '',
        function_type: null,
        cooperation_type: null
      },
      rules: {
        campaign_name: [
          { required: true, validator: validateCampaignName, trigger: 'blur' }
        ],
        function_type: [
          { required: true, message: this.$t('请选择Function'), trigger: 'change' }
        ],
        cooperation_type: [
          { required: true, message: this.$t('请选择合作性质'), trigger: 'change' }
        ],
        introduction: [
          {
            required: false, validator: validateIntro, trigger: 'blur'
          }
        ]
      },
      campaign_attachment: {}
    }
  },
  computed: {
    brands () {
      return this.brandCategorys.length !== 0 ? this.brandCategorys.find(b => b.brand_category_id === this.form.brandCategory).children : []
    },
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  async mounted () {
    await this.getBrandTreeStructure()
    if (this.$route.query.star) {
      this.starList = JSON.parse(this.$route.query.star)
    }
    if (this.$route.query.status) {
      this.userStatus = this.$route.query.status
      this.sendActivateEmail()
      if (this.isZh) {
        this.alertText = this.userStatus === '3' ? this.$t('当前账号未激活。系统已向') + this.$route.query.mail + this.$t('发送了一封激活邮件，请按照邮件指引完成激活。你仍可以完成本次项目创建，但必须激活后才能进行后续操作') + '。'
          : this.$t('当前账号未注册。系统已向') + this.$route.query.mail + this.$t('发送了一封注册邀请邮件，请按照邮件指引完成注册和激活。你仍可以完成本次项目创建，但必须激活后才能进行后续操作') + '。'
      } else {
        this.alertText = this.userStatus === '3' ? 'Your account is not activated. The system has sent an activation email to ' + this.$route.query.mail + '. Please complete the account activation according to the email instructions. You can still complete the project creation, but you must activate your account before proceeding.'
          : 'Your account is not registered. An invitation to register has been sent from the system to ' + this.$route.query.mail + '. Please complete the account activation according to the email instructions. You can still complete the project creation, but you must activate your account before proceeding.'
      }
    }
    if (this.$route.query.campaignId) {
      this.$store.dispatch('unistar/getCampaignInfo', this.$route.query.campaignId)
      this.form = {
        campaign_name: this.campaignInfo.campaign_name,
        campaign_brand: this.campaignInfo.brand,
        introduction: this.campaignInfo.introduction,
        function_type: this.campaignInfo.function_type,
        cooperation_type: this.campaignInfo.cooperation_type === '品牌代言' ? 1 : 2
      }
      this.starList = this.campaignInfo.campaign_star
      this.brandLists = this.campaignInfo.brand.map(i => {
        return this.brandCategorys.find(o => o.brand_category_id === i.brand_category_id).children
      })
      this.campaign_attachment = this.campaignInfo.brief
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isSaved) {
      this.$confirm(this.$t('离开本页面，已更改的信息将不会被保存。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          return next()
        })
        .catch(() => {
          return next(false)
        })
    } else {
      return next()
    }
  },
  methods: {
    uploadSuccess (res) {
      this.campaign_attachment = {
        file_path: res.file_path,
        file_download_path: res.file_download_path,
        file_name: res.file_name,
        remark: this.campaign_attachment.remark
      }
    },
    shouldDisabledBrand (index, id) {
      const selectedCategoryId = this.form.campaign_brand[index].brand_category_id
      const selectedBrands = this.form.campaign_brand.filter(i => i.brand_category_id === selectedCategoryId)
        .map(v => v.brand_id)
      return selectedBrands.includes(id)
    },
    onChangeFunction () {
      this.form.campaign_brand = [
        {
          brand_category_id: '',
          brand_id: ''
        }
      ]
    },
    handleDeleteBrand (index) {
      this.form.campaign_brand.splice(index, 1)
      this.brandLists.splice(index, 1)
    },
    handleAddBrand () {
      this.form.campaign_brand.push({
        brand_category_id: '',
        brand_id: ''
      })
      this.brandLists.push([])
    },
    onBrandCategoryChange (val, index) {
      this.brandLists[index] = this.brandCategorys.find(b => b.brand_category_id === val).children
      this.form.campaign_brand[index].brand_id = null
      // const firstBrand = this.brandLists[index][0]
      // if (firstBrand) {
      //   this.form.campaign_brand[index].brand_id = firstBrand.brand_id
      // }
    },
    async  getBrandTreeStructure () {
      this.loading = true
      try {
        const res = await axios
          .get('/common/getBrandTreeStructure', {
            params: {
              campaign_type: 1
            }
          })
        let arr = []
        arr = res.filter(i => {
          return i.status !== 0
        })
        arr.forEach((i, idx) => {
          arr[idx] = i
          arr[idx].children = i.children.filter(v => v.status !== 0)
        })
        this.brandCategorys = arr
        this.form.brandCategory = this.brandCategorys[0].brand_category_id
        this.form.brand = this.brandCategorys[0].children[0].brand_id
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    submit () {
      if (this.campaign_attachment.file_path == null) {
        this.$message.error(this.$t('请上传附件'))
        return
      }

      const params = {
        servlet_path: this.$route.path,
        is_final_scope: 0,
        campaign: {
          campaign_name: this.form.campaign_name,
          introduction: this.form.introduction,
          function_type: this.form.function_type,
          cooperation_type: this.form.cooperation_type
        },
        campaign_brand: this.form.campaign_brand.map(i => {
          return {
            brand_id: i.brand_id,
            brand_category_id: i.brand_category_id
          }
        }),
        campaign_attachment: {
          remark: this.campaign_attachment.remark,
          file_path: this.campaign_attachment.file_path
        },
        star_info: this.starList.map(i => {
          return {
            external_id: i.external_id,
            star_name: i.star_name
          }
        })
      }

      let apiPath = '/management/star/saveCampaignAndBrief'
      if (this.$route.query.campaignId && this.$route.query.taskId) {
        apiPath = '/management/star/updateCampaignAndBrief'
        params.campaign.campaign_id = this.campaignInfo.campaign_id
        params.task_id = this.$route.query.taskId
      }
      this.loading = true

      axios
        .post(apiPath, format4backend(params))
        .then((res) => {
          this.isSaved = true
          this.loading = false
          this.$store.commit('unistar/setCampaignInfo', res)
          if (this.userStatus === '1') {
            this.$router.push('/unistar/campaign-overview')
          } else {
            this.$confirm(this.$t('项目创建成功。请尽快完成账户激活，否则将无法查看项目进度及完成后续操作。'), this.$t('提示'), {
              confirmButtonText: this.$t('确定'),
              cancelButtonText: this.$t('取消')
            })
              .then(() => {
                this.$router.push('/unistar/campaign-overview')
              })
              .catch(() => {
                this.$router.push('/campaign/list')
              })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancel () {
      this.$router.go(-1)
    },
    async onConfirm () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$validator.validate().then(result => {
            if (result) {
              this.submit()
            }
          })
        }
      })
    },
    sendActivateEmail () {
      axios.get('/admin/user/sendActivateEmail', {
        params: {
          status: this.userStatus
        }
      })
        .then(res => {

        })
        .catch(err => {
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.new-unistar-campaign
  .el-alert
    margin-bottom 12px
  .el-form
    // padding 0 20px
    .el-form-item__label
      text-align left
      width 16.66667%
  .brand-container
    width 422px
    padding 20px 20px 0 20px
    border 1px dashed #ccc
    box-sizing border-box
    .el-form-item
      .el-form-item__label
        width 160px
      .el-form-item__content
        width 220px
  .form-item
    padding-left 20px
    .el-form-item__label
      width 150px

  .delete-brand__btn
    margin-top 70px
    color red
    margin-left 10px
.mr-15
  margin-right 15px

.new-unistar-campaign__header
  font-size: 16px
  padding-bottom: 20px

.new-unistar-campaign__all-permission
  padding 0 20px 20px
  > span
    margin-right 15px

.new-unistar-campaign__form-permission
  display flex
  justify-content flex-end
  > span
    margin-right 10px

.new-unistar-campaign__form
  .el-input
    width 200px
  .el-select
    width 200px
  .footer-button
    padding-top 20px
    padding-left 200px
  .el-checkbox__label,.el-form-item__content,.el-radio__label
    font-size 12px

.new-unistar-campaign__sub_final_scope
  padding-left 150px
  .divider
    margin 5px
  > span:nth-child(1)
    display inline-block
    width 300px
    text-overflow ellipsis
    overflow hidden
    white-space nowrap
    margin-rigth 20px
</style>
